const discountCodeFn = () => {
  const discountCodeEles = document.querySelectorAll('div.discount-code-snippet .discount-code');

  discountCodeEles.forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();

      const current = e.currentTarget.parentNode.querySelector('.discount-success-msg');
      const curr = e.currentTarget.querySelector('span');
      const discountCode = e.currentTarget.dataset.id;
      const loaderClass = e.currentTarget.parentNode.querySelector('.codecopy-loader');

      loaderClass.style.display = 'block';
      current.style.display = 'none';

      try {
        await fetch(`/discount/${discountCode}`, { method: 'GET' });
        current.style.display = 'block';
        current.innerHTML = 'Code applied';
        curr.classList.remove('before-apply');
        curr.classList.add('after-apply');
        discountCodeFn(); // Reinitialize event listeners
      } catch (err) {
        console.error(err);
      } finally {
        loaderClass.style.display = 'none';
      }
    });
  });
};

const offersCodeSlider = () => {
  const sliderEles = document.querySelectorAll('.offer_slider');

  sliderEles.forEach(slide => {
    new Swiper(slide, {
      loop: true,
      speed: 800,
      autoplay: { delay: 2500 },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
  });
};

const updateOfferWidget = (data) => {
  const totalPrice = data.total_price / 100;
  const discountPricings = document.querySelectorAll('.discount-code-desc-inner.not-zero-price');

  discountPricings.forEach(disEle => {
    const discountCodeEle = disEle.querySelector('.discount-code');
    const disPrice = parseInt(discountCodeEle.dataset.discountPrice, 10);
    const messageElem = disEle.querySelector('.discount-success-msg.not-zero-price');

    if (totalPrice >= disPrice) {
      discountCodeEle.classList.remove('disabled');
      messageElem.classList.remove('error-animation');
      messageElem.innerHTML = 'Tap to apply code';
    } else {
      const remainingAmount = theme.Currency.formatMoney((disPrice - totalPrice) * 100, window.shopSettings.moneyFormat);
      discountCodeEle.classList.add('disabled');
      messageElem.classList.add('error-animation');
      messageElem.innerHTML = `To activate this offer, add <strong>${remainingAmount}</strong> more to your cart.`;
    }
  });

  offersCodeSlider();
  discountCodeFn();
};

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.codecopy-loader').forEach(loader => loader.style.display = "none");

  offersCodeSlider();
  discountCodeFn();

  const cartSummaryEle = document.querySelector('mini-cart');
  if (cartSummaryEle) {
    const cartUpdateMutation = new MutationObserver(() => {
      fetch('/cart.json')
        .then(res => res.json())
        .then(updateOfferWidget)
        .catch(err => console.error(err));
    });

    cartUpdateMutation.observe(cartSummaryEle, { childList: true, attributes: true, attributeFilter: ['class'] });
  }
});
